import React from 'react';
import {map} from 'lodash';
import './TableUserInfo.scss';
import {formatMillisecondsDate} from "../../../utils/general";
import moment from 'moment';

const TableUserInfo = ({data, linkToUserInfo = false, adminEmails = []}) => {

  if (!(data) || data === {}) {
    return null;
  }

  const handleDownload = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    const fileName = `felt_${data.email}_${formattedDate}.csv`;

    // Generate CSV content
    const csvContent = generateCSVContent();

    // Create a temporary anchor element
    const anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
    anchor.download = fileName;
    anchor.style.display = 'none';

    // Append the anchor element to the document body
    document.body.appendChild(anchor);

    // Trigger the click event on the anchor element
    anchor.click();

    // Remove the anchor element from the document body
    document.body.removeChild(anchor);
  };

  const generateCSVContent = () => {
    // Header row
    const csvData = data.userByEmail;
    const headerRow = Object.keys(csvData).join(',');

    // Data rows
    const dataRow = Object.values(csvData).join(',');

    // Combine header row and data row
    const csvContent = [headerRow, dataRow].join('\n');

    return csvContent;
  };

  return (
    <>
      <div className="TableUserInfo-container">
        <table>
          <thead>
          <tr>
            <th>Email</th>
            <th>ID</th>
            <th>LANG</th>
            <th>Adult role</th>
            <th>Saw Paywall</th>
            {/* do not delete: <th>Passed Fakedoor</th> */}
            {/* do not delete: <th>Subscribe Likelihood</th> */}
            {/* do not delete: <th>Reasons not subscribed</th> */}
            {/* do not delete: <th>Explanation not subscribed</th> */}
            {/* do not delete: <th>Sessions Num</th> */}
            <th>Joined Date</th>
            <th>Last Seen</th>
            <th>Catbears Role</th>
            <th>hasProgApp</th>
            <th>hasProgFelt</th>
            {/* do not delete: <th>Device</th> */}
          </tr>
          </thead>
          <tbody>
          {(() => {
            const rows = map(data, (v) => v);
            const compute = (item) => {
            const {exitPoll = {}} = item;
            const sawPaywall = !!item?.userLog?.log?.some?.((e) => e?.eventName === 'PAYWALL_OPENED');
            let lastSeenMs = null;
                const upd = item?.updatedAt ? (Number(item.updatedAt) || new Date(item.updatedAt).getTime()) : null;
                const crt = item?.createdAt ? (Number(item.createdAt) || new Date(item.createdAt).getTime()) : null;
                lastSeenMs = upd || crt || null;
            return { item, exitPoll, sawPaywall, lastSeenMs };
            };
            const enriched = rows.map(compute).sort((a,b) => (b.lastSeenMs || 0) - (a.lastSeenMs || 0));
            return enriched.map(({item, exitPoll, sawPaywall, lastSeenMs}) => {
            const isAdmin = Array.isArray(adminEmails) && adminEmails.includes(String(item.email || '').toLowerCase());
            const hasProgApp = !!(item.userProgress && (
              // New flat format: { progressById: { [id]: { completed: bool } } }
              (item.userProgress.progressById &&
                Object.values(item.userProgress.progressById).some(v => v?.completed)) ||
              // Old nested format: { courses: [...] }
              (Array.isArray(item.userProgress.courses) &&
                item.userProgress.courses.some(course =>
                  course.completed ||
                  (Array.isArray(course.lessons) && course.lessons.some(lesson =>
                    lesson.completed ||
                    (Array.isArray(lesson.steps) && lesson.steps.some(step =>
                      step.completed ||
                      (Array.isArray(step.stepItems) && step.stepItems.some(si => si.completed))
                    ))
                  ))
                ))
            ));
            const hasProgFelt = Array.isArray(item.relationships) && item.relationships.length > 0;
            // Log the row data for debugging/admin purposes
            try {
              const rowLog = {
                'Email': item.email,
                'ID': item.id,
                'LANG': item.locale,
                'Adult role': item.adultRole,
                'Saw Paywall': sawPaywall ? 'Yes' : 'No',
                'Passed Fakedoor': item.isSubscribed ? 'Yes' : 'No',
                'Subscribe Likelihood': exitPoll?.subscriptionLikelihood ?? null,
                'Reasons not subscribed': Array.isArray(exitPoll?.reasons) ? exitPoll.reasons.join(', ') : (exitPoll?.reasons ?? null),
                'Explanation not subscribed': exitPoll?.explanation ?? null,
                'Joined Date': item.createdAt ?? null,
                'Last Seen': lastSeenMs ?? item.updatedAt ?? null,
                'Catbears Role': isAdmin ? 'Admin' : '--'
              };
              // eslint-disable-next-line no-console
              console.log('[Admin UserInfo] Row', rowLog);
            } catch (_) {}
            return (
              <tr key={item.id}>
                <td>
                  {linkToUserInfo ? (
                    <a href={`/admin/userinfo?email=${encodeURIComponent(item.email || '')}`} style={{ color: 'var(--color-skyblue)' }} target="_blank" rel="noopener noreferrer">
                      {item.email}
                    </a>
                  ) : (
                    item.email
                  )}
                </td>
                <td>
                  {linkToUserInfo ? (
                    <a href={`/admin/userinfo?id=${encodeURIComponent(item.id || '')}`} style={{ color: 'var(--color-skyblue)' }} target="_blank" rel="noopener noreferrer">
                      {item.id}
                    </a>
                  ) : (
                    item.id
                  )}
                </td>
                <td>{item.locale}</td>
                <td>{item.adultRole || '-'}</td>
                <td className={"tableBox_bool_" + sawPaywall}>{sawPaywall ? 'Yes' : 'No'}</td>
                {/* do not delete: <td className={"tableBox_bool_" + item.isSubscribed}>{item.isSubscribed ? 'Yes' : 'No'}</td> */}
                {/* do not delete: <td>{exitPoll?.subscriptionLikelihood}</td> */}
                {/* do not delete: <td className="tableBox_M">{exitPoll?.reasons}</td> */}
                {/* do not delete: <td className="tableBox_L">{exitPoll?.explanation}</td> */}
                {/* do not delete: <td>{item.sessionsNum}</td> */}
                <td className="tableBox_S">{formatMillisecondsDate(item.createdAt)}</td>
                <td className="tableBox_S">{lastSeenMs ? moment(lastSeenMs).format('DD/MM/yyyy HH:mm') : '-'}</td>
                <td className="tableBox_S">{isAdmin ? 'Admin' : '--'}</td>
                <td className={"tableBox_bool_" + hasProgApp}>{hasProgApp ? 'Yes' : 'No'}</td>
                <td className={"tableBox_bool_" + hasProgFelt}>{hasProgFelt ? 'Yes' : 'No'}</td>
                {/* do not delete: <td>{item.device}</td> */}
              </tr>)
            });
          })()}
          </tbody>
        </table>
      </div>
      {/* <div className="TableUserInfo-button userinfo_button userinfo_button__s " onClick={handleDownload}>
        ↓ Download CSV
      </div> */}
    </>
  );
};

export default TableUserInfo;